//npm install exceljs
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BillPrint from './Saleprint';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import ReactDOM from 'react-dom';
import PrintIcon from '@mui/icons-material/Print';
import InfoIcon from '@mui/icons-material/Info';
import CreateIcon from '@mui/icons-material/Create';
import { Tooltip } from '@mui/material';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AddIcon from '@mui/icons-material/Add';

function SIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, companyId, userId, logout, token, roleName } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, token, logout, roleName]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {

        fetchData('SaleApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });

    };

    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };


    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    //USING HERE THE EXCEL TEMPLATE 


    // const handlePrint = async (saleid) => {
    //     try {
    //         const response = await fetchData('SaleDetailsApi', `/SalePrint/${saleid}`, token);
    //         const labelData = response.response_data.SalePrint;
    //         const labelItemData = response.response_data.SalePrintItems;
    //         const excelUrl = process.env.PUBLIC_URL + '/PrinterPeople.xlsx';
    //         // Fetch the Excel file
    //         const excelResponse = await fetch(excelUrl);
    //         const excelBuffer = await excelResponse.arrayBuffer();
    //         // Create a new workbook
    //         const workbook = new ExcelJS.Workbook();
    //         // Load the workbook from the buffer
    //         await workbook.xlsx.load(excelBuffer);
    //         // Access the first worksheet
    //         const worksheet = workbook.getWorksheet(1);
    //         // Parse the date string into a Date object
    //         const invoiceDate = new Date(labelData.InvoiceDate);
    //         // Extract day, month, and year
    //         const day = String(invoiceDate.getDate()).padStart(2, '0');
    //         const month = String(invoiceDate.getMonth() + 1).padStart(2, '0');
    //         const year = invoiceDate.getFullYear();
    //         const formattedDate = `${day}/${month}/${year}`;

    //         // Populate data into Excel template
    //         worksheet.getCell('L2').value = formattedDate;
    //         worksheet.getCell('C2').value = labelData.InvoiceNumber;
    //         worksheet.getCell('C3').value = `Customer Name & Address: ${labelData.Customer}, ${labelData.CustomerAddress}, ${labelData.LandMark}, ${labelData.PinCode}`;
    //         worksheet.getCell('E3').value = `Delivery Address:  ${labelData.CustomerAddress}, ${labelData.LandMark}, ${labelData.PinCode}`;
    //         worksheet.getCell('L28').value = labelData.NetAmount;
    //         worksheet.getCell('L29').value = labelData.CGSTAmount;
    //         worksheet.getCell('L30').value = labelData.SGSTAmount;
    //         worksheet.getCell('L31').value = labelData.IGSTAmount;
    //         worksheet.getCell('L32').value = labelData.IGSTAmount;
    //         worksheet.getCell('L33').value = labelData.DiscountPer;
    //         worksheet.getCell('L34').value = labelData.RoundOff;
    //         worksheet.getCell('L35').value = labelData.TotalAmount;
    //         worksheet.getCell('D6').value = labelData.Details;

    //         // sale items 
    //         let j = 5;

    //         for (let i = 0; i < labelItemData.length; i++) {
    //             const saleItem = labelItemData[i];
    //             j = j + 1;
    //             worksheet.getCell('A' + j).value = saleItem.HSNCODE;
    //             worksheet.getCell('B' + j).value = saleItem.spare;

    //             worksheet.getCell('F' + j).value = saleItem.Quantity;
    //             worksheet.getCell('G' + j).value = saleItem.Rate;

    //             worksheet.getCell('H' + j).value = saleItem.Rate;

    //             worksheet.getCell('J' + j).value = saleItem.CGRate;
    //             worksheet.getCell('L' + j).value = saleItem.SGRate;

    //             worksheet.getCell('M' + j).value = saleItem.Amount;
    //         }

    //         // Before generating the Blob from the workbook, protect the worksheet
    //         worksheet.protect('efftabs@123', {
    //             selectLockedCells: true,
    //             selectUnlockedCells: true,
    //             formatCells: false,
    //             formatColumns: false,
    //             formatRows: false,
    //             insertColumns: false,
    //             insertRows: false,
    //             insertHyperlinks: false,
    //             deleteColumns: false,
    //             deleteRows: false,
    //             sort: false,
    //             autoFilter: false,
    //             pivotTables: false,
    //             objects: false,
    //             scenarios: false,
    //         });

    //         // Generate a Blob from the workbook
    //         const buffer = await workbook.xlsx.writeBuffer();
    //         const blob = new Blob([buffer], { type: 'application/octet-stream' });

    //         // Create a temporary URL for the Blob
    //         const url = URL.createObjectURL(blob);

    //         // Trigger the download
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = 'Invoice.xlsx';
    //         document.body.appendChild(a); // Append to body to ensure compatibility with more browsers
    //         a.click();
    //         document.body.removeChild(a); // Clean up

    //         // Revoke the temporary URL to free up memory
    //         URL.revokeObjectURL(url);

    //         // Inform the user
    //         // alert("Your file has been downloaded. Please open it using your Excel application. The file is protected; use the password 'efftabs@123' to open. To print the document, please use the print option in Excel.");
    //     } catch (error) {
    //         console.error('Error:', error);

    //     }
    // };


    const handlePrint = async (saleid) => {
        try {
            const response = await fetchData('SaleDetailsApi', `/SalePrint/${saleid}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                {/* <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bold' }}>Sale</h4> */}
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SALE</h6>
                <Tooltip title="Search Sale Item Here">
                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '200px' }}
                            />
                        )}
                    </div>
                </Tooltip>
                {/* <Button
                    component={Link}
                    to="/SaleCreate"
                    className="linkcolor"
                    style={{ marginLeft: '8px', fontWeight: 'bolder' }}
                >
                    <AddIcon /> CREATE
                </Button> */}
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    {/* <Table>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', color: 'white' }}>Date</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '100px', color: 'white' }}>Bill No</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', color: 'white' }}>Company</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', color: 'white' }}>Name</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', color: 'white' }}>Contact</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', color: 'white' }}>Amount</TableCell>
                                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '150px', color: 'white' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead> */}
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', width: '20px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Company</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        {/* <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                         filteredData.map((item, index) => (
                            <TableRow key={item.Id} >
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc' }}>{index + 1}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>{item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB')}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '100px' }}>{item.invoiceNo}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerCompany}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerName}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerContact}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>{item.totalAmount}</TableCell>
                                <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>
                                    <Tooltip title=" Invoice Print ">
                                        <IconButton onClick={() => handlePrint(item.id)}>
                                            <PrintIcon style={{ color: '#5F2F53' }} />
                                        </IconButton>
                                    </Tooltip>
                                    {roleName !== "Engineer" && (
                                        <Tooltip title=" Sale Edit ">
                                            <Link to={`/saleEdit/${item.id}`}>
                                                <IconButton>
                                                    <EditIcon style={{ color: 'brown' }} />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                    )}

                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody> */}

                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id}>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>
                                        {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-GB') : '-'}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '100px' }}>{item.invoiceNo}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerCompany}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerName}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerContact}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>
                                        {item.totalAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>
                                        <Tooltip title="Invoice Print">
                                            <IconButton onClick={() => handlePrint(item.id)}>
                                                <PrintIcon style={{ color: '#5F2F53' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {roleName !== "Engineer" && (
                                            <Tooltip title="Sale Edit">
                                                <Link to={`/saleEdit/${item.id}`}>
                                                    <IconButton>
                                                        <EditIcon style={{ color: 'brown' }} />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>


                    </Table>


                </TableContainer>
            </div>


        </div>
    );
}

export default SIndex;

